import { Entity, PrimaryKey, Property } from '@mikro-orm/postgresql'

@Entity({ tableName: 'translations' })
export class Translation {
	@PrimaryKey()
	@Property({ primary: true, autoincrement: true })
	id!: number

	@Property()
	appcomponent_id!: string

	@Property()
	locale!: string

	@Property({ type: 'jsonb' })
	translation_text!: any

	@Property()
	updated_at?: Date
}
